export default "__VITE_ASSET__BUWXfcOL__"